import Menu from './menu'
import MenuItem from './menuItem'
import MenuCollapse from './menuCollapse'
import MenuGroup from './menuGroup'

Menu.MenuItem = MenuItem
Menu.MenuCollapse = MenuCollapse
Menu.MenuGroup = MenuGroup

export default Menu